import {
  BodyText,
  CaptionText,
  HeadingText,
  Icon,
  Button,
  Container,
  Row,
  Col,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React, { memo } from 'react'

const shoppingModalConfig = [
  {
    icon: 'website',
    title: 'paypalShopping.learnHow.header1',
    descriptions: ['paypalShopping.learnHow.desc1'],
  },
  {
    icon: 'online-shopping',
    title: 'paypalShopping.learnHow.header2',
    descriptions: [
      'paypalShopping.learnHow.desc2',
      'paypalShopping.learnHow.desc3',
    ],
  },
]

const ShoppingHowItWorks = memo(({ onSectionClick, focusLink }) => (
  <Container form id="shoppingHowItWorks">
    <Row noGutters align="center" className="pnw_shopping_howitworks__header">
      <Col xs="auto">
        <HeadingText size="lg" id="shoppingHowItWorksTitle">
          <Message id="paypalShopping.learnHow.title" />
        </HeadingText>
      </Col>
    </Row>
    <Row noGutters className="pnw_shopping_howitworks__content">
      <Col>
        {shoppingModalConfig.map(({ icon, title, descriptions }) => (
          <Container form key={icon}>
            <Row
              noGutters
              className="pnw_shopping_howitworks__content-title-row"
            >
              <Col xs="auto">
                <Icon name={icon} id={icon} color="sysColorAccent1Main" />
              </Col>
              <Col>
                <BodyText id={`${icon}Title`}>
                  <Message id={title} />
                </BodyText>
              </Col>
            </Row>
            <Row noGutters align="center">
              <Col xs="auto">
                <Icon
                  name={icon}
                  color="sysColorAccent1Main"
                  className="pnw_shopping_howitworks__content-desc-icon"
                />
              </Col>
              <Col>
                {descriptions.map((description) => (
                  <CaptionText
                    key={description}
                    className="pnw_shopping_howitworks__content-desc-text"
                  >
                    <Message id={description} />
                  </CaptionText>
                ))}
              </Col>
            </Row>
          </Container>
        ))}
      </Col>
    </Row>
    <Row noGutters align="center" className="pnw_shopping_howitworks__footer">
      <Col xs={12} className="pnw_shopping_howitworks__footer-col">
        <Button
          id="gotItBtn"
          secondary
          data-testid="gotItBtn"
          onClick={() => {
            focusLink()
            onSectionClick({})
          }}
        >
          <Message id="paypalShopping.learnHow.button.title" />
        </Button>
      </Col>
    </Row>
  </Container>
))

ShoppingHowItWorks.displayName = 'shoppingHowItWorks'

export default ShoppingHowItWorks
